<template>
  <section id="an-ca-sa-view" class="fill-height">
    <template v-if="session && session_response && session_response.marking_layout">
      <embed :src="base64toBlob(session_response.marking_layout)" width="100%" height="600px">
<!--      <iframe :src="`data:application/pdf;base64,${session_response.marking_layout}`"-->
<!--             width="100%"-->
<!--             height="100%"-->
<!--             type="application/pdf"/>-->
    </template>

    <v-container fluid v-if="session.mock">
      <v-card class="my-3">
        <v-toolbar dense flat color="blur">Extra Tasks</v-toolbar>
        <v-card-text>
          <ol><li v-for="task in session.mock.additional_tasks" :key="task.id">{{ task.body }}</li></ol>
        </v-card-text>
        <v-divider/>
        <v-card-text>
          <p>
            Please note: We can not provide individual feedback for the above tasks, but you may check your answer
            against answers of other students in our Interview Case Studies Google Classroom, subject to your consent
            to share your answers with the  others in the same classroom under OSCEsmart Creative Commons License.
            In such a way, we jointly make a community database of answers! Submission of your answer with us
            shall amount to participation in the above scheme.
          </p>
          <p>
            In order to get access to other drafts, please  email your works to <a href="mailto:attendance.note.osce@gmail.com">
            attendance.note.osce@gmail.com
          </a>
          </p>
          <p>
            In order to obtain the access, please join our Client Interview Case Studies via
            <a href="https://classroom.google.com/c/MjczMzQzMjQzNDla?cjc=2vwgpnk">https://classroom.google.com/c/MjczMzQzMjQzNDla?cjc=2vwgpnk</a>
          </p>
        </v-card-text>
      </v-card>
    </v-container>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import {base64StringToBlob, createObjectURL} from "blob-util";
export default {
  props: {
    session: {
      type: Object,
      default: null
    },
    event_data: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    session_response: null,
  }),
  computed: {
    ...mapGetters({profile_type: 'getAuthUserProfileType'}),
  },
  created() {
    this.loadSessionResponse()
  },
  methods: {
    loadSessionResponse() {
      this.axios.get(`api/user/sessions/${this.$route.params.session_id}/response`)
          .then(({data}) => { this.session_response = data.data})
    },
    base64toBlob(base64Data) {
      const blob = base64StringToBlob(base64Data, 'application/pdf');
      return createObjectURL(blob)
    },
  }
}
</script>